// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#indicatorWrapper {
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    position: absolute;
    left: 0;
    height: 250px;
    color: white;
    text-align: center;
    padding-bottom: 20px;
    border-top-right-radius: 10px;
}

#indicatorParametersWrapper {
    bottom: 300px;
    height: 300px;
    position: absolute;
    left: 0;
    color: white;
    text-align: center;
    display: none;
    background: steelblue;
}

#indicatorParametersWrapper>div {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
    border: 1px solid black;
    background: rgba(0, 0, 0, 0.6)
}

img.indicatorInfo {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    cursor: pointer;
}

#indicatorParametersWrapper>div:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -30px;
    width: 0;
    height: 0;
    border-bottom: solid 30px rgba(70, 130, 180, 0.8);
    border-left: solid 30px transparent;
    border-right: solid 30px transparent;
}

.parameters {
    display: none;
}

.controlWrapper {
    padding: 10px 20px 0 20px;
}

#indicatorCategories>div {
    margin-top: 10px;
    min-width: 300px;
    float: left;
}

#indicatorCategories select {
    width: 80%;
    height: 220px;
}

#indicatorCategories option {
    padding: 7px;
}

#indicatorCategories option.customSelectedOption {
    background: steelblue !important;
    color: white;
}

.indicatorHeading {
    font-size: 1.5em;
}

.indicatorParameterHeading {
    font-size: 1.1em;
    font-weight: bold;
}

.indicatorDocumentation {
    display: none;
    font-style: italic;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 1px;
    background: yellow;
    color: black;
}

/*CSS for indicator parameter controls*/
.rangeslider {
    margin-top: 3px;
}

option:checked {
    background: transparent;
    color: inherit;
    /* Adjust color to fit your design */
}

.multiselect {
    width: 100%;
}

.multiselect option {
    padding: 7px;
}

.multiselect option:checked {
    background: #ff1579;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/css/indicators.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iDAAiD;IACjD,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":["#indicatorWrapper {\n    background: rgba(0, 0, 0, 0.6);\n    bottom: 0;\n    position: absolute;\n    left: 0;\n    height: 250px;\n    color: white;\n    text-align: center;\n    padding-bottom: 20px;\n    border-top-right-radius: 10px;\n}\n\n#indicatorParametersWrapper {\n    bottom: 300px;\n    height: 300px;\n    position: absolute;\n    left: 0;\n    color: white;\n    text-align: center;\n    display: none;\n    background: steelblue;\n}\n\n#indicatorParametersWrapper>div {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    border: 1px solid black;\n    background: rgba(0, 0, 0, 0.6)\n}\n\nimg.indicatorInfo {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 30px;\n    cursor: pointer;\n}\n\n#indicatorParametersWrapper>div:after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -30px;\n    width: 0;\n    height: 0;\n    border-bottom: solid 30px rgba(70, 130, 180, 0.8);\n    border-left: solid 30px transparent;\n    border-right: solid 30px transparent;\n}\n\n.parameters {\n    display: none;\n}\n\n.controlWrapper {\n    padding: 10px 20px 0 20px;\n}\n\n#indicatorCategories>div {\n    margin-top: 10px;\n    min-width: 300px;\n    float: left;\n}\n\n#indicatorCategories select {\n    width: 80%;\n    height: 220px;\n}\n\n#indicatorCategories option {\n    padding: 7px;\n}\n\n#indicatorCategories option.customSelectedOption {\n    background: steelblue !important;\n    color: white;\n}\n\n.indicatorHeading {\n    font-size: 1.5em;\n}\n\n.indicatorParameterHeading {\n    font-size: 1.1em;\n    font-weight: bold;\n}\n\n.indicatorDocumentation {\n    display: none;\n    font-style: italic;\n    width: 100%;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 1px;\n    background: yellow;\n    color: black;\n}\n\n/*CSS for indicator parameter controls*/\n.rangeslider {\n    margin-top: 3px;\n}\n\noption:checked {\n    background: transparent;\n    color: inherit;\n    /* Adjust color to fit your design */\n}\n\n.multiselect {\n    width: 100%;\n}\n\n.multiselect option {\n    padding: 7px;\n}\n\n.multiselect option:checked {\n    background: #ff1579;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
